/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const e = ["Luni", "Mar\u021Bi", "Miercuri", "Joi", "Vineri", "S\xE2mb\u0103ta", "Duminic\u0103"], a = ["Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie", "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie"], i = "Ani", t = "An", n = "Lun\u0103", r = "S\u0103pt\u0103m\xE2n\u0103", s = "Zi", u = "Azi", d = "Nici o interac\u021Biune", o = "Toat\u0103 ziua", m = "\u0218terge", M = "Adaug\u0103 un eveniment", c = "dddd D MMMM YYYY", y = { weekDays: e, months: a, years: "Ani", year: "An", month: "Lun\u0103", week: "S\u0103pt\u0103m\xE2n\u0103", day: "Zi", today: "Azi", noEvent: "Nici o interac\u021Biune", allDay: "Toat\u0103 ziua", deleteEvent: "\u0218terge", createEvent: "Adaug\u0103 un eveniment", dateFormat: "dddd D MMMM YYYY" };
export {
  o as allDay,
  M as createEvent,
  c as dateFormat,
  s as day,
  y as default,
  m as deleteEvent,
  n as month,
  a as months,
  d as noEvent,
  u as today,
  r as week,
  e as weekDays,
  t as year,
  i as years
};
